module.exports = __webpack_public_path__ + "static/media/headimage1.c237a698.jpg";